export const REFRESH_USER_COUNT = "REFRESH_USER_COUNT";

import { get, put, post, destroy, upload } from "utils/fetchRequest";

export const getExchangeList = async (searchText) => {
  try {
    const result = await get(
      `exchange${searchText ? `?search=${searchText}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getPriceContent = async (newsId) => {
  try {
    const result = await get(`exchange/${newsId}`);
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const createExchange = async (data) => {
  try {
    const result = await post("exchange", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const updateExchange= async (id, data) => {
  try {
    const result = await put(`exchange/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const deleteExchange = async (id) => {
  try {
    const result = await destroy(`exchange/${id}`);

    return result;
  } catch (err) {
    return { error: err };
  }
};
